import "./landing-page-arrowed-list-item.component.scss";

export default {
    template: require('./landing-page-arrowed-list-item.component.html'),
    transclude: true,
    controller: function () {
        'ngInject';
    }
};
